<template>
    <div class="corpinfo-list">
        <v-status-bar v-if="tipInfo.show === 1" kind="wait" show-close-icon @close="closeTip">
            {{ tipInfo.message }}
        </v-status-bar>
        <v-page-header :title="$t('企业资料')">
            <example slot="extra" />
        </v-page-header>
        <div class="corpinfo-main">
            <div class="avatar">
                <img :src="main_info.eLogo || logo" class="avatar-main">
            </div>
            <div class="info">
                <div class="company-header">
                    <div slot="title" class="company-header-name">
                    {{ main_info.eName }}
                    <v-tag v-if="corpAdmin.need_verify && main_info.status" v-bind="{...statusInfo}" icon-fixed class="company-header-status" />
                    </div>
                    <div slot="extra" class="main-opt">
                        <combos :combos-info="combosInfo" />
                        <v-button type="link" kind="primary" icon="basic_edit_line" class="opt-btn" remote @click.prevent="editCorp">
                            {{ $t('编辑') }}
                        </v-button>
                    </div>
                </div>
                <div class="info-list">
                    <v-descriptions :col="2">
                        <v-description-item
                            v-for="(item, index) in mainInfoList"
                            :key="index"
                            :col="2"
                            :text="$t(item.text)"
                            size="small"
                        >

                            <span v-if="item.key === 'eFullName'" class="corp-fullname-value">
                                <span>{{ main_info.eFullName || '-' }}</span>
                                <v-button
                                    v-if="showSyncBtn"
                                    kind="primary"
                                    size="small"
                                    class="sync-btn"
                                    :loading="syncLoading"
                                    :disabled="syncLoading"
                                    @click="syncCorpName"
                                >
                                    {{ $t('同步') }}
                                </v-button>
                                <v-icon
                                    v-if="showSyncBtn"
                                    v-tip:syncHelpTip.hover.delay500
                                    name="basic_help_line"
                                    remote
                                    class="sync-help-icon"
                                />
                                <v-tip v-if="showSyncBtn" ref="syncHelpTip" placement="top" kind="small">
                                    <div class="sync-help-content">
                                        {{ $t('点击"同步"按钮，会读取腾讯云中企业全称。若需要修改企业全称，可前往腾讯云') }}<a href="https://cloud.tencent.com/document/product/378/61029" target="_blank">{{ $t('「修改企业全称」') }}</a>{{ $t('。若出现同步失败问题，可联系客服进行咨询。') }}
                                    </div>
                                </v-tip>
                            </span>
                            <span v-else-if="item.key === 'eIndustry'">{{ getIndustry(main_info.eIndustry.area, main_info.eIndustry.areaDetail, industrylist, translate) }}</span>
                            <span v-else-if="item.key === 'eAddress'">{{ getAddress(main_info.eAddress, province, main_info.eAddressDetail, translate) }}</span>

                            <span v-else>
                                {{ main_info[item.key] || '-' }}
                            </span>
                        </v-description-item>
                    </v-descriptions>
                </div>
            </div>
        </div>
        <div v-if="corpAdmin.need_related_corp" class="corpinfo-releated">
            <v-page-header :title="$t('关联企业')" level="section"><span slot="caption">{{ $t('最多可添加200个关联企业') }}</span></v-page-header>
            <v-tip ref="disabledtip" placement="top">
            {{ $t('最多添加 200 个') }}
            </v-tip>
            <div class="corpinfo-releated-opt">
                <v-button v-if="pagination.total >= 200" v-tip:disabledtip.hover icon="basic_new_line" class="create-btn" kind="primary" disabled>
                    {{ $t('添加关联企业') }}
                </v-button>
                <v-button v-else icon="basic_new_line" class="create-btn" kind="primary" :disabled="pagination.total >= 200" @click="createdRelatedDlg = true">
                    {{ $t('添加关联企业') }}
                </v-button>
                <v-input v-model.trim="searchKeyWord" kind="search" :placeholder="$t('企业名称')" @search="searchRelatedCorp" />
            </div>
            <v-table
                :data="related_list"
                :header-fix="true"
                :pagination="pagination"
                :auto="false"
                :loading="loading"
                @paginationChange="paginationChange"
            >
                <v-table-column
                    v-for="column in columns"
                    :key="column.label"
                    :column-key="column.columnKey"
                    :label="$t(column.label)"
                    :align="column.align"
                    :formatter="column.formatter"
                    :render="column.render"
                    :width="column.width"
                    :min-width="column.minWidth"
                />
                <v-table-column
                    key="status"
                    width="200"
                    column-key="status"
                    :label="$t('状态')"
                    name="status"
                    align="left"
                >
                    <template
                        slot="cell"
                        slot-scope="props"
                    >
                        <span class="table-err">
                            <v-tag :kind="statusKind[props.row.status != 1 && props.row.status != 2 ? 3 : props.row.status]" type="status" :status-text="$t(statusText[props.row.status != 1 && props.row.status != 2 ? 3 : props.row.status])" />
                            <v-icon v-if="props.row.status != 1 && props.row.status != 2" v-tip.hover.delay500="`errTip${props.row.related_id}`" name="basic_help_line" remote class="table-err-icon" />
                            <v-tip
                                :ref="`errTip${props.row.related_id}`"
                                placement="top-end"
                                kind="small"
                                clazz="corpinfo-err-tip"
                            >
                                <div class="corpinfo-err-content">
                                    <reviewFailed :error="props.row.error" @resetInfo="resetInfo(props.row)" />
                                </div>
                            </v-tip>
                        </span>
                    </template>
                </v-table-column>
                <v-table-column
                    key="opt"
                    width="100"
                    column-key="operate"
                    name="operate"
                    align="left"
                >
                    <template
                        slot="cell"
                        slot-scope="props"
                    >
                        <v-button
                            class="table-action-edit"
                            type="link"
                            kind="primary"
                            @click.prevent="editRelated(props.row)"
                        >
                            {{ $t('编辑') }}
                        </v-button>
                        <v-button
                            v-show="props.row.status != 1"
                            v-popconfirm="`delete${props.index}`"
                            class="table-action-del"
                            type="link"
                            kind="primary"
>
                            {{ $t('删除') }}
                        </v-button>
                        <v-popconfirm :ref="`delete${props.index}`"
                            :use-arrow="false"
                            placement="bottom-end"
                            :footer-config="{
                                primary: {
                                    text: $t('删除'),
                                    kind: 'warning'
                                },
                                cancel: {
                                    text: $t('取消'),
                                }
                            }"
                            @confirm="handleDelete(props.row)"
                        >
                            <div class="confirm-text" style="width: 210px">
                                {{ $t('确定要删除该关联企业吗？删除后，将不会在企业资料卡中展示。') }}
                            </div>
                        </v-popconfirm>
                    </template>
                </v-table-column>
                <template slot="nodata">
                    <div v-if="searchKeyWord" class="nodata">
                        <v-icon name="default_search" remote class="nodata-icon" />
                        <span>{{ $t('暂未搜索到该关联企业') }}</span>
                    </div>
                    <div v-else class="nodata">
                        <v-icon name="default_common" remote class="nodata-icon" />
                        <span>{{ $t('暂未关联任何企业') }}</span>
                    </div>
                </template>
            </v-table>
            <v-dialog v-model="createdRelatedDlg" kind="modal" :title="$t('添加关联企业？')" :confirm-text="$t('添加')" @confirm="editRelated">
                <div class="corpinfo-create">
                {{ $t('添加的关联企业必须是主企业的分公司或子公司或法人代表名字一致才会审核通过') }}
                </div>
            </v-dialog>
        </div>
    </div>
</template>
<script>
import { logo, statusText, statusKind } from '../utils/defaultConfig';
import { columns, mainInfoList } from '../utils/columns';
import { province } from '../utils/province';
import { getAddress, getIndustry } from '../utils/formatter';
import Gateway from '@/utils/Gateway';

import example from '../components/example.vue';
import combos from '../components/combos.vue';
import reviewFailed from '../components/review-failed.vue';
export default {
    components: {
        example,
        combos,
        reviewFailed,
    },
    props: {
        corpAdmin: {
            type: Object,
            default: () => ({
                need_verify: true,
                need_attachment: true,
                need_sms_code: true,
                need_related_corp: true,
            }),
        },
        industrylist: {
            type: Object,
            default: () => {},
        },
        combosInfo: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            getAddress,
            getIndustry,
            province,
            statusText,
            statusKind,
            related_list: [],
            columns,
            pagination: {
                count: 15,
                index: 1,
                showQuick: true,
            },
            loading: false,
            main_info: {
                eFullName: '',
                eName: '',
                eDesc: '',
                eIndustry: {
                    area: '',
                    areaDetail: '',
                },
                eLogo: '',
                eAddress: {
                    province: 0,
                    city: 0,
                },
                eAddressDetail: '',
                ePhone: '',
                eEmail: '',
                eHome: '',
                signature: '',
                eAttachment: [],
                status: '',
                error: [],
                lastVTime: '',
                corpMigrateFlag: 0,
                phoneType: 2,
            },
            mainInfoList,
            logo,
            tipInfo: {},
            searchKeyWord: '',
            createdRelatedDlg: false,
            syncLoading: false,
            showSyncBtn: false,
        };
    },
    computed: {
        statusInfo() {
            const { status } = this.main_info;
            switch (status) {
                case '1':
                    return {
                        text: this.$t('审核中'),
                        preIcon: 'basic_message_record_line',
                        color: 'orange',
                    };
                case '2':
                    return {
                        text: this.$t('审核不通过'),
                        preIcon: 'basic_error_line',
                        color: 'red',
                   };
                default:
                    return {
                        text: this.$t('审核通过'),
                        preIcon: 'basic_finish_line',
                        color: 'green',
                    };
            }
        },
    },
    async created() {
        // 获取主企业信息
        const res = await this.$ajax.gatewayGet('/mng/account/corpInfo/getCorpInfo').catch(err => {
            this.$message.error(err.message || this.$t('网络故障，请稍后再试'));
        });
        this.main_info = res?.data || this.main_info;
        this.main_info.id = window.QD_ADMIN_COMMON?.data?.profile?.kfuin || '';
        // 获取关联企业
        if (this.corpAdmin.need_related_corp) this.getReletedList();
        if (this.main_info.corpMigrateFlag) this.getMigrateTips();
        // 判断是否展示同步企业全称按钮
        this.checkSyncBtnVisible();
    },
    methods: {

        checkSyncBtnVisible() {
            Gateway.post('/v1/boss/audit/uin_by_name_account', {})
                .then((data) => {
                    this.showSyncBtn = !!(data && data.uin);
                })
                .catch(() => {
                    this.showSyncBtn = false;
                });
        },
        async syncCorpName() {
            this.syncLoading = true;
            try {
                const res = await Gateway.post('/v1/boss/audit/sync_corp_name', {});
                const { changed, corp_name: corpName, message } = res || {};
                if (changed) {
                    this.$message.success(message || this.$t('同步成功'));
                    this.main_info.eFullName = corpName;
                } else {
                    this.$message.warning(message || this.$t('企业全称已是最新'));
                }
            } catch (err) {
                this.$message.error(err || this.$t('同步失败，请稍后重试'));
            } finally {
                this.syncLoading = false;
            }
        },

        translate(key) {
            return this.$t(key);
        },
        searchRelatedCorp() {
            this.paginationChange(1, this.pagination.count);
        },
        getReletedList() {
            this.$ajax.gatewayPost('/v1/basic/corp/corp/relatedCorpPendingList', {
                size: this.pagination.count,
                index: this.pagination.index,
                keywords: this.searchKeyWord,
            }).then((res) => {
                const { data } = res;
                this.related_list = data.related_corp_pending_info.map(item => ({
                    ...item,
                    industryText: getIndustry(item.industry.category, item.industry.sub_category, this.industrylist, this.translate),
                    addressText: getAddress(item.address, this.province, item.address_detail, this.translate),
                })) || [];
                this.pagination.total = data.total || 0;
            });
        },
        paginationChange(pageNum, pageSize) {
            this.pagination.count = pageSize;
            this.pagination.index = pageNum;
            this.getReletedList();
        },
        editRelated(data) {
            this.$emit('edit', {
                info: data,
                // 1表示主企业，2表示关联企业
                type: 2,
            });
        },
        editCorp() {
            this.$emit('edit', {
                info: this.main_info,
                // 1表示主企业，2表示关联企业
                type: 1,
            });
        },
        handleDelete(data) {
            this.$ajax.gatewayPost('/v1/basic/corp/corp/deleteRelatedCorp', {
                related_id: data.related_id,
            }).then(() => {
                this.$set(this.pagination, 'index', 1);
                this.getReletedList();
            });
        },
        getMigrateTips() {
            this.$ajax.post('/hp/MigrateTips/GetMigrateTips', {
                type: 4,
            }).then((res) => {
                this.tipInfo = res || {};
            });
        },
        closeTip() {
            this.$ajax.post('/hp/MigrateTips/delMigrateTips', {
                type: 4,
            });
        },
        resetInfo(row) {
            this.$ajax.gatewayPost('/v1/basic/corp/corp/renewRelatedCorpInfo', {
                related_id: row.related_id,
            }).then(() => {
                this.getReletedList();
            })
            .catch((err) => {
                this.$message.error(err.message || this.$t('网络故障，请稍后再试'));
            });
        },
    },
};
</script>
<style lang="less" scoped>
.corpinfo-list {
    .fullName {
        display: flex;
        align-items: center;
    }
    .logo {
        width: 32px;
        height: 32px;
        border-radius: 100%;
        margin-right: var(--spacing-base);
    }
    /deep/ .table-cell-content {
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .create-btn {
        margin-bottom: var(--spacing-loose);
    }
    .table-action-edit {
        margin-right: var(--spacing-loose);
    }
    .corp-fullname-value {
        display: inline-flex;
        align-items: center;
    }
    .sync-btn {
        margin-left: 8px;
    }
    .sync-help-icon {
        color: var(--color-text-caption);
        margin-left: 4px;
        cursor: pointer;
        vertical-align: middle;
    }
    .sync-help-content {
        max-width: 300px;
        line-height: 1.5;
        a {
            color: var(--color-brand);
        }
    }
}
.corpinfo-main {
    padding: 16px 32px;
    box-sizing: content-box;
    display: flex;
    flex-direction: row;
    gap: 24px;
    border-radius: 8px;
    border: 1px solid var(--color-border-active);
    background: var(--color-bg-contrast);
    .avatar {
        display: flex;
        align-items: center;
        &-main {
            width: 100px;
            height: 100px;
            border-radius: 100%;
        }
    }
    .info {
        flex: 1;
    }
    .company-header {
        display: flex;
        justify-content: space-between;
        font-size: 32px;
        font-style: normal;
        font-weight: 600;
        line-height: 40px;
        margin-bottom: 16px;
        &-name {
            display: inline-flex;
            align-items: center;
        }

        &-status {
            margin-left: 13px;
        }
    }
    .opt-btn {
        vertical-align: top;
        margin-left: 20px;
    }
}
.corpinfo-releated {
    &-opt {
        display: flex;
        width: 100%;
        flex-direction: row;
        justify-content: space-between;
    }
}
.table-err {
    display: inline-flex;
    align-items: center;
    &-icon {
        color: var(--color-text-caption);
        margin-left: var(--spacing-tight);
    }
}
.nodata {
    display: flex;
    flex-direction: column;
    &-icon {
        width: 120px;
        height: 116px;
    }
}
</style>
<style lang="less">
.corpinfo-err {
    &-tip {
        max-width: 450px;
    }

    &-content {
        display: inline-flex;
        flex-direction: column;
    }
}
.corpinfo-create {
    width: 320px;
    text-align: left;
    color: var(--color-text-caption);
}
</style>
